import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import MarketingTracking from './MarketingTracking';

async function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Marketing & Tracking',
    component: <AdminLayout><MarketingTracking /></AdminLayout>,
  };
}

export default action;
